"use client";

import React from "react";

import { Button } from "@repo/design-system";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { EnumLogoutRedirect, isAuthenticated, useLogout } from "@auth/index";

export default function LayoutError() {
  const { t } = useTranslation(["button", "message"]);
  const queryClient = useQueryClient();
  const isSignedIn = isAuthenticated();

  const { logout } = useLogout();

  const handleClearAndReload = async () => {
    try {
      queryClient.clear();

      // TODO: discuss with the team — it is not clear why a layout error should
      // end the user's session. Figure out whether the logout is load-bearing
      // here or a leftover, and drop it if it is not.
      if (isSignedIn) {
        await logout(EnumLogoutRedirect.Never);
      }
    } catch (error) {
      console.error("Cleanup error:", error);
    } finally {
      window.location.href = "/";
    }
  };

  return (
    <>
      <div className="relative flex min-h-[82vh] flex-col items-center justify-center overflow-hidden px-4 py-8">
        <div className="flex flex-col items-center gap-3 text-center">
          <p className="text-2xl font-medium text-contentPrimary">
            {t("page_error_message", { ns: "message" })}
          </p>
          <p className="text-base text-contentSecondary max-w-xs leading-relaxed">
            {t("page_error_description", { ns: "message" })}
          </p>
          <p className="text-sm text-contentTertiary max-w-xs leading-relaxed">
            {t("error_clear_cookies", { ns: "message" })}
          </p>
          <Button
            className="mt-2"
            variant="primary"
            onPress={handleClearAndReload}>
            {t("reload_page", { ns: "button" })}
          </Button>
        </div>
      </div>
    </>
  );
}
